<template>
<div class="dashboard">
    <div class="content">
        <p class="page-title">{{ $route.name }}</p>
        <div class="stats" v-if="usage">
            <div class="card" @click="goTo('/forms')">
                <p class="stat">
                    {{ usage.forms }}
                    <span>Forms</span>
                </p>
                <img src="@/assets/img/Inventory.svg" />
            </div>
            <div class="card" @click="goTo('/locations')">
                <p class="stat">
                    {{ usage.locations }}
                    <span>Locations</span>
                </p>
                <img src="@/assets/img/location.svg" />
            </div>
            <div class="card" @click="goTo('/employees')">
                <p class="stat">
                    {{ usage.employees }}
                    <span>Employees</span>
                </p>
                <img src="@/assets/img/employee.svg" />
            </div>

            <div class="card" @click="goTo('/visitors')">
                <p class="stat">
                    {{ usage.visitors }}
                    <span>Visitors</span>
                </p>
                <img src="@/assets/img/visitor.svg" />
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { db, auth } from "../firebaseConfig.js";
import moment from "moment-timezone"

export default {
    data() {
        return {
            usage: {
                forms: 0,
                locations: 0,
                employees: 0,
                visitors: 0,
            },
            manager: this.$store.state.manager,
        };
    },
    firestore() {
        return {
            usage: db.collection("usage").doc(this.user_doc.id),
        };
    },

    methods: {
        goTo(path) {
            if (this.manager) {
                const permissions = this.manager.permissions;
                if (permissions[path]) {
                    return this.$router.push({
                        path: path
                    });
                }
            } else {
                this.$router.push({
                    path: path
                });
            }
        }
    },
};
</script>

<style lang="scss">
.stats {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    max-width: 800px;

    .card {
        width: 49%;
        position: relative;
        padding-top: 70px;
        transition: box-shadow 0.3s;

        @media screen and (max-width: 700px) {
            width: 100% !important;
            padding: 20px;
            padding-top: 40px;
        }

        cursor: pointer;

        &:hover {
            box-shadow: 0 0 15px rgba(128, 128, 128, 0.8);
        }

        img {
            position: absolute;
            z-index: 0;
            opacity: 0.1;
            height: 80%;
            right: 10%;
            top: 50%;
            transform: translateY(-50%);
        }

        .stat {
            font-size: 80px;
            color: #00bf6f !important;
            font-weight: 500;
            margin: 0;

            @media screen and (max-width: 700px) {
                font-size: 60px;
            }

            span {
                display: block;
                font-size: 16px;
                color: #132628;
                font-weight: 500;
                margin-top: -10px;
            }
        }
    }
}
</style>
